import { TaskItem } from '@all-manager/design-system-v2';
import { OpenTaskWithSubTopic } from '../../../../types';
import { useOpenTaskItem } from './useOpenTaskItem';

type Props = {
  task: OpenTaskWithSubTopic;
};

export default function OpenTaskItem(props: Props) {
  const hook = useOpenTaskItem(props);

  return (
    <TaskItem
      task={props.task}
      subTopicHref={hook.targetUrl}
      onSubTopicClick={hook.handleSubTopicClick}
      onChange={hook.handleToggle}
      disabled={!hook.isAdmin}
    />
  );
}

export { OpenTaskItem };
